import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useHistory } from 'react-router-dom';
import Swal from "sweetalert2";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileContract, faCamera, faArrowCircleRight, faCheckCircle, faEdit, faEye, faPauseCircle, faTrash, faLock, faHistory } from '@fortawesome/free-solid-svg-icons'
import { resetPermissions, trans } from './Components/utils';
// import 'datatables.net-responsive'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
 import * as JSZip from "jszip";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.JSZip = JSZip;


var DataTableComp = ({ SystemUrl, CurrentModule, Columns, Params, FilterParams,RoleId }) => {
    const transfiles = { en: "DataTables/English.json", ar: 'DataTables/Arabic.json' }


    let ajaxUrl = SystemUrl + CurrentModule
    const $ = require("jquery");
    let DataTable = require("datatables.net-bs4");
    let buttons = require('datatables.net-buttons')();
    // const links = { "AssetItem": "AssignAssetItem", 'AssignAssetItem': "RoomSpaceItem" };
    const links = {
        "AssetItem" : "AssignAssetItem" ,
        'AssignAssetItem' : "RoomSpaceItem" ,
        // "RoomSpaceItem" : "PlanPreventiveMaintenance", //deprecared
        "MyAsset" : "PlanPreventiveMaintenance"
    };
    require("datatables.net-responsive-bs4");
    require("jquery-datatables-checkboxes");
    require('datatables.net-buttons/js/buttons.print.js')();
    require('datatables.net-buttons/js/buttons.html5.js')();
    require('datatables.net-buttons/js/buttons.colVis.js')();
    require('datatables.net-buttons/js/dataTables.buttons.js');

    const CurrentModuleObj = JSON.parse(localStorage.getItem(CurrentModule));
    const PermissionModuleObj = JSON.parse(localStorage.getItem("Permission"));

    let userRole = localStorage.getItem('userRole');
    let deleteRecord = (url, type = "Delete") => {
        //Show Sweetalert for confirmation first before submit
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warsetColumns(res.data)ning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${type} it!`
        }).then((result) => {
            if (result.isConfirmed) {
                //Submit to delete
                axios.delete(url)
                    .then(jsonRes => {
                        if (CurrentModule == "Page" || CurrentModule == "Role") {
                            resetPermissions(CurrentModule)
                        } else {
                            $("#datatable").DataTable().ajax.reload()
                        }
                    }).catch((res) => {
                        Swal.fire(
                            `You cannot delete this item because it has relations in following modules`,
                            `(${res.response.data.msg})`,
                            'error'
                        );
                    })

            }
        });
    }

    const history = useHistory();

    const routeChange = path => {
        history.push(path);
    }

    const [modal, setModal] = useState(null);

    const columnsDefs = [
        {
            targets: 1,
            'checkboxes': {
                'selectRow': true
            },
            orderable: false,
            className: "all",
        },
        {

            targets: -1,
            orderable: false,
            className: "all",
            width: "285px",
            createdCell: (td, cellData, full) => ReactDOM.render(

                // <NavLink  to={} className="btn btn-primary btn-sm">
                //     <i className="fas fa-edit"></i>
                // </NavLink>
                <>
                    <div style={{ width: 285 }}>
                        {
                            !!CurrentModuleObj.edit &&
                            !!CurrentModuleObj.page_edit &&
                            !(userRole == 34 && CurrentModule == "MyAsset") &&
                            <button
                                data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Edit')}
                                onClick={() => {
                                    let url = "/" + CurrentModule + "/Edit/" + full.id;
                                    routeChange(url);
                                }}
                                className="btn btn-primary btn-sm">
                                <FontAwesomeIcon icon={faEdit} />


                            </button>
                        }

                        {
                            !!CurrentModuleObj.del &&
                            !!CurrentModuleObj.page_del &&
                            !(userRole == 34 && CurrentModule == "MyAsset") &&
                            <button
                                data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Delete')}
                                className="btn btn-danger btn-sm"
                                onClick={() => {
                                    let url = ajaxUrl + "/" + full.id;
                                    deleteRecord(url);
                                }}>
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        }
                        {/*    {*/}
                        {/*        !!CurrentModuleObj.suspend &&*/}
                        {/*        !!CurrentModuleObj.page_suspend &&*/}

                        {/*        (full.status == "approved" ?*/}
                        {/*                <button*/}
                        {/*                    data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Suspend')}*/}
                        {/*                    className="btn btn-warning btn-sm"*/}
                        {/*                    onClick={() => {*/}
                        {/*                        let url = ajaxUrl + "/" + full.id + '?status=suspend';*/}
                        {/*                        deleteRecord(url, 'Suspend');*/}
                        {/*                    }}>*/}
                        {/*                    <FontAwesomeIcon icon={faPauseCircle}/>*/}
                        {/*                </button> : <button*/}
                        {/*                    data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Approve')}*/}
                        {/*                    className="btn btn-info btn-sm"*/}
                        {/*                    onClick={() => {*/}
                        {/*                        let url = ajaxUrl + "/" + full.id + '?status=approve';*/}
                        {/*                        deleteRecord(url, 'Approve');*/}
                        {/*                    }}>*/}
                        {/*                    <FontAwesomeIcon icon={faCheckCircle}/>*/}
                        {/*                </button>)*/}
                        {/*}*/}
                        {

                            !!CurrentModuleObj.has_view ?
                                <button
                                    data-container="body" data-toggle="tooltip" data-placement="top" title={trans('View')}
                                    className="btn btn-success btn-sm"
                                    onClick={() => {
                                        let url = "/" + CurrentModule + "/View/" + full.id;
                                        routeChange(url);
                                    }}>
                                    <FontAwesomeIcon icon={faEye} />
                                </button> : ""
                        }

                        {
                        typeof links[CurrentModule] !== "undefined" 
                        &&
                        (
                            (
                                CurrentModule == "AssignAssetItem" 
                                &&
                                full.has_allocation == false
                            )
                            ||
                            (
                                (
                                    CurrentModule == "MyAsset" 
                                    &&
                                    full.has_ppm == false
                                ) 
                                ||
                                CurrentModule != "MyAsset"
                            )
                            // || //deprecared
                            // ( //deprecared
                            //     CurrentModule != "AssignAssetItem"  //deprecared
                            //     && //deprecared
                            //     ( //deprecared
                            //         ( //deprecared
                            //             CurrentModule == "RoomSpaceItem"  //deprecared
                            //             && //deprecared
                            //             full.has_ppm == false //deprecared
                            //         )  //deprecared
                            //         || //deprecared
                            //         CurrentModule != "RoomSpaceItem" //deprecared
                            //     ) //deprecared
                            // ) //deprecared
                        ) ?
                            localStorage.getItem(links[CurrentModule]) &&
                            <button
                                data-container="body" data-toggle="tooltip" data-placement="top" title={trans(JSON.parse(localStorage.getItem(links[CurrentModule])).name_en)}
                                className="btn btn-info btn-sm"
                                onClick={() => {
                                    let url = "/" + links[CurrentModule] + "/Add/" + full.id;
                                    routeChange(url);
                                }}>
                                <FontAwesomeIcon icon={faArrowCircleRight} />
                            </button> : ""
                        }


                        {/*{ CurrentModule== "RoomSpaceItem" ?*/}
                        {/*    <button*/}
                        {/*        data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Track Asset / Item')}*/}
                        {/*        className="btn btn-info btn-sm"*/}
                        {/*        onClick={() => {*/}
                        {/*            let url = "/AssetItem/View/" + full.assign_asset_item.asset_item.id+"?AllocateID="+full.id;*/}
                        {/*            routeChange(url);*/}
                        {/*        }}>*/}
                        {/*        <FontAwesomeIcon icon={faFileContract} />*/}
                        {/*    </button> : ""*/}
                        {/*    }*/}

                        {CurrentModule == "Role" &&
                        !!PermissionModuleObj.edit &&
                        !!PermissionModuleObj.page_edit ?
                            <button
                                data-container="body" onClick={() => {
                                    let url = "/Permissions/" + full.id;
                                    routeChange(url);
                                }} className="btn btn-info btn-sm" data-toggle="tooltip" title={trans('Permissions')}>
                                <FontAwesomeIcon icon={faLock} />
                            </button>
                            : ""
                        }
                        {(CurrentModule == "InventoryTaking" && full.can_start == true) ?
                            <button
                                data-container="body" onClick={() => {
                                let url = "/InventoryTaking/Scan/" + full.id;
                                routeChange(url);
                            }} className="btn btn-info btn-sm" data-toggle="tooltip" title={trans('Start Taking')}>
                                <FontAwesomeIcon icon={faCamera} />
                            </button>
                            : ""
                        }
                        {CurrentModule == "Ticket" && full.status == "open" ?
                            <button
                                data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Convert to WO')}
                                className="btn btn-info btn-sm"
                                onClick={() => {
                                    let url = "/WorkOrder/Add/" + full.id;
                                    routeChange(url);
                                }}>
                                <FontAwesomeIcon icon={faArrowCircleRight} />
                            </button> : ""}
                        <button
                            data-container="body" data-toggle="tooltip" data-placement="top" title={trans('Activity Log')}
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                                let url = "/ActivityLog/"+CurrentModule+"/" + full.id;
                                routeChange(url);
                            }}>
                            <FontAwesomeIcon icon={faHistory} />
                        </button>

                        {RoleId > 0 &&
                        <button data-container="body" data-toggle="tooltip" data-placement="top" title={trans('User Activity Log')}
                            className="btn btn-dark btn-sm"
                            onClick={() => {
                                let url = "/ActivityLogPerUser/"+ full.id;
                                routeChange(url);
                            }}>
                            <FontAwesomeIcon icon={faHistory} />
                        </button>  }
                    </div>
                </>
                , td)

        },
        {
            orderable: false,
            className: 'select-checkbox',

            // createdCell: (td, cellData, full) => ReactDOM.render(
            //     <>
            //             <p>sa</p>
            //     </>, td)
        }
    ];

    useEffect(() => {
        // begin first table
        $.fn.dataTable.ext.errMode = 'none';
        $('#datatable').DataTable({
            responsive: true,
            searchDelay: 50,
            processing: true,
            serverSide: true,
            ajax: {
                "url": ajaxUrl + Params,
                "data": function (data) {

                    FilterParams.forEach(el => {
                        // if (el != "role_id" && !!Params) {
                        if (el != "role_id") {
                            data[el] = function () {
                                return $(`select[name="data[${el}]"]`).val() || $(`input[name="data[${el}]"]`).val();
                            }
                        }
                        // }
                    })
                },
                xhrFields: {
                    withCredentials: true
                }
            },
            columns: Columns,
            "order": [[0, "desc"]],
            columnDefs: columnsDefs,
            'select': {
                'style': 'multi'
            },
            lengthMenu:[ [10, 25, 50, 100,1000, -1], [10, 25, 50, 100,1000, "All"] ],
            dom: '<"top"<"left-col"B><"center-col"l><"right-col"f>>rtip',
            buttons: [
                'csv',
                'excelHtml5',
                {
                    extend: 'print', exportOptions:
                        { columns: ':visible' }
                },
                {
                    extend: 'pdf', exportOptions:
                        { columns: [0, 1, 2, 3, 4] }
                },
                { 
                    extend: 'colvis', postfixButtons: ['colvisRestore'] 
                },
                {
                    extend: 'copy', exportOptions:
                    { columns: [0, ':visible'] }
                },
            ],

            language: {
                url: transfiles[localStorage.getItem('lang') || 'en']
            }, "drawCallback": function (settings, json) {
                window.$('[data-toggle="tooltip"]').tooltip();

            }
        });

    }, []);
    return (
        <div class="table-responsive">
            <table
                id="datatable"
                className="table table-striped table-hover  dt-responsive responsive"
                width="100%"
                cellSpacing="0"
            />
        </div>
    );
}
export default DataTableComp;
